import _ from "@/boot/lodash";
import { IFilter, IFiltersOptions } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import { FraudStatus } from "@/data/enums";
import { FraudEventTypes, FraudStatusMap } from "@/data/fraud";
import i18n from "@/i18n";

const FraudEventsFilters: () => IFilter[] = () => {
  return [
    {
      key: "invoice.id",
      label: i18n.t("_.order__id"),

      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL,
      group: "order"
    },
    {
      key: "invoice.number",
      label: i18n.t("_.invoice_number"),

      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL,
      group: "invoice"
    },
    {
      key: "invoice.ip",
      label: i18n.t("_.ip"),

      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL,
      group: "invoice"
    },
    {
      key: "client.email",
      label: i18n.t("_.client_email"),

      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL,
      group: "client"
    },
    {
      key: "created_at",
      label: i18n.t("_.created_at"),

      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL,
      group: "event"
    },
    {
      key: "status",
      label: i18n.t("_.status"),

      type: FilterTypes.SELECT_CHECKBOX,
      operator: FilterOperators.EQUAL,
      options: _.map(_.orderBy(FraudStatusMap(), ["id", "asc"]), status => ({
        value: `${status.id}`,
        label: status.label
      })) as IFiltersOptions[]
    },
    {
      key: "reason",
      label: i18n.t("_.reason"),

      type: FilterTypes.SELECT_CHECKBOX,
      options: FraudEventTypes().map(i => ({
        value: `${i.id}`,
        label: i.label as string
      })),
      operator: FilterOperators.EQUAL,
      group: "event"
    }
  ];
};

const FraudDetectionFilters: IFilter[] = [
  {
    key: "created_at",
    label: i18n.t("_.date_added"),

    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  },
  {
    key: "level",
    label: i18n.t("_.level"),
    type: FilterTypes.SELECT_CHECKBOX,
    options: [
      {
        value: `${FraudStatus.NOT_FRAUD}`,
        label: i18n.t("_.whitelist").toString()
      },
      {
        value: `${FraudStatus.REVIEW}`,
        label: i18n.t("_.greylist").toString()
      },
      { value: `${FraudStatus.FRAUD}`, label: i18n.t("_.blacklist").toString() }
    ],
    operator: FilterOperators.EQUAL
  }
];

export { FraudEventsFilters, FraudDetectionFilters };
